<div class="postgallery__outer">
  <div class="mdc-layout-grid">
    <div class="mdc-layout-grid__inner">
      <div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-12">
        @if (post?.gallery) {
        <section mat-card-image class="jumbotron post__gallery postgallery__wrapper">
          <planone-swiper
            [showSlideNav]="true"
            [swiperOptions]="{
              effect: 'fade',
              fadeEffect: {
                crossFade: true
              }
            }"
            (interaction)="trackSwiperInteraction($event)">
            @if (post?.gallery) { @for (image of post?.gallery; track identifyImage($index, image)) {
            <ng-template #slide>
              <img
                [src]="image.resource | ImageUrl : image.provider"
                width="100%"
                height="auto"
                [alt]="image?.description" />
            </ng-template>
            } @for (image of post?.gallery; track identifyImage($index, image)) {
            <ng-template #title>{{ image?.description }}</ng-template>
            } }
          </planone-swiper>
        </section>
        }
      </div>
    </div>
  </div>
</div>
